<template>
  <BaseContainer>
    <div class="archive-nav">
      <div class="archive-nav__wrapper">
        <div class="archive-nav__filters">
          <BaseButton class="archive-nav__button" variant="filter" rounded="full" width="small">All</BaseButton>
          <BaseButton
            class="archive-nav__button active"
            variant="filter"
            rounded="full"
            width="small"
          >Corporate</BaseButton>
          <BaseButton
            class="archive-nav__button"
            variant="filter"
            rounded="full"
            width="small"
          >Our Food</BaseButton>
          <BaseButton
            class="archive-nav__button"
            variant="filter"
            rounded="full"
            width="small"
          >Speeches &amp; Presentations</BaseButton>
          <BaseButton
            class="archive-nav__button"
            variant="filter"
            rounded="full"
            width="small"
          >Suppliers</BaseButton>
          <BaseButton
            class="archive-nav__button"
            variant="filter"
            rounded="full"
            width="small"
          >Foundation</BaseButton>
          <BaseButton
            class="archive-nav__button"
            variant="filter"
            rounded="full"
            width="small"
          >People</BaseButton>
        </div>
        <div class="archive-nav__select">
          <FormSelect tint/>
        </div>
      </div>
    </div>
  </BaseContainer>
</template>

<script>
import BaseContainer from '../elements/BaseContainer.vue'
import FormSelect from '../elements/FormSelect.vue'
import BaseButton from '../elements/BaseButton.vue'

export default {
  name: 'ArchiveNav',
  components: { BaseContainer, BaseButton, FormSelect },
  data() {
    return {
      isActive: false
    }
  },
  methods: {
    toggleActive() {
      this.isActive = !this.isActive
    }
  }
}
</script>

<style lang="postcss">
.archive-nav {
  @apply mt-8;
}
.archive-nav__wrapper {
  @apply flex flex-wrap justify-between py-6;
}
.archive-nav__select {
  @apply w-full;
}
.archive-nav__button {
  @apply mb-4 mx-2;
}
@screen md {
  .archive-nav__wrapper {
    @apply flex-no-wrap;
  }
  .archive-nav__filters {
    @apply w-8/12;
  }
  .archive-nav__select {
    @apply w-4/12 pl-6;
  }
  .archive-nav__button {
    @apply mb-4 ml-0 mr-4;
  }
}
@screen lg {
  .archive-nav__wrapper {
    @apply py-0;
  }
}
</style>
